'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Svg = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends__default["default"]({
    width: "1em",
    height: "1em",
    viewBox: "0 0 300 300",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M271 135.507C271 210.331 210.33 271 135.498 271 60.664 271 0 210.331 0 135.507 0 60.67 60.664 0 135.497 0c74.833 0 135.504 60.669 135.504 135.507",
    id: "broker-rating-success_svg__a"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    id: "broker-rating-success_svg__c",
    d: "M0 0h156.964v78.105H0z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__namespace.createElement("g", {
    transform: "translate(15 15)"
  }, /*#__PURE__*/React__namespace.createElement("mask", {
    id: "broker-rating-success_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React__namespace.createElement("use", {
    xlinkHref: "#broker-rating-success_svg__a"
  })), /*#__PURE__*/React__namespace.createElement("use", {
    fill: "#19DC9B",
    xlinkHref: "#broker-rating-success_svg__a"
  }), /*#__PURE__*/React__namespace.createElement("use", {
    fillOpacity: 0.3,
    fill: "#3F3E4B",
    xlinkHref: "#broker-rating-success_svg__a"
  }), /*#__PURE__*/React__namespace.createElement("g", {
    mask: "url(#broker-rating-success_svg__b)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M67.173 165.425s10.942-6.791 12.451-13.206c1.51-6.414 1.51-19.62 4.905-26.412 3.396-6.792 7.924-9.056 8.301-12.451l.377-3.396 1.51-6.415s4.905-8.3 5.282-12.074c.377-3.773 2.641-13.206 7.547-9.81 4.905 3.396.377 30.563-.378 36.977-.754 6.414.755 19.998 33.581-6.792 32.827-26.79 39.619-31.317 44.901-26.79 5.283 4.529-32.826 38.487-32.826 38.487l44.523-34.713s4.57-3.875 10.188-.755c13.583 7.547-42.26 47.165-42.26 47.165l38.11-26.412s5.189-5.587 9.055-.755c7.546 9.433-44.524 47.165-44.524 47.165s32.45-23.017 38.11-15.47c5.66 7.546-58.485 53.579-58.485 53.579L92.076 212.59l-24.903-47.165Z",
    fill: "#D69480"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M107.168 211.835s3.396-2.64-5.66-12.451c-9.055-9.81-16.224-17.357-17.733-26.79-1.51-9.433-21.13-30.94-18.112-37.354 3.019-6.414 12.83-4.528 22.262 6.037 9.433 10.565 9.056 15.47 15.093 16.602 6.037 1.132 11.697-33.581 11.32-42.637-.378-9.055.754-41.882 9.055-41.505 8.3.378 5.66 43.392 7.923 43.77 0 0 1.887-49.807 1.51-52.07-.378-2.265 1.903-6.79 6.037-6.415 16.602 1.51 11.697 70.558 11.697 70.558s-5.66-61.503 6.791-61.503c12.452 0 10.565 63.39 10.565 63.39s3.019-39.241 9.433-39.241c6.415 0 7.924 77.727-3.773 99.234-11.697 21.507-14.715 36.223-14.715 36.223l-51.693-15.848Z",
    fill: "#E2AD9D"
  }), /*#__PURE__*/React__namespace.createElement("g", {
    transform: "matrix(-1 0 0 1 73.964 180.895)"
  }, /*#__PURE__*/React__namespace.createElement("mask", {
    id: "broker-rating-success_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React__namespace.createElement("use", {
    xlinkHref: "#broker-rating-success_svg__c"
  })), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#233359",
    mask: "url(#broker-rating-success_svg__d)",
    d: "m34.336 0 122.628 78.105-122.628-.755L0 50.56z"
  })), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#364770",
    d: "M65.286 161.275 36.61 179.009l40.75 59.616 19.243-16.602zM169.048 229.57l-65.276-19.621s-9.433 32.826-7.169 32.826c2.264 0 71.69 15.47 71.69 15.47l.755-28.676Z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#233359",
    d: "m91.637 266.465 6.853-23.69 64.521 13.584-4.39 21.279z"
  }))), /*#__PURE__*/React__namespace.createElement("path", {
    d: "m39.022 103.692-.065 4 38.073.619.065-4-38.073-.619Zm128.312-83.425-12.37 35.44 3.777 1.318 12.37-35.44-3.777-1.318Zm-38.87 15.09-1.57 15.733 3.981.397 1.57-15.733-3.981-.397ZM67.107 63.985l-2.35 3.237 13.394 9.726 2.35-3.237-13.394-9.726ZM82.529 25.41l16.19 33.33 3.597-1.748-16.189-33.33-3.598 1.748ZM217.908 218.4l-3.816 1.2 11 35 3.816-1.2-11-35Zm25.72-13.562-3.255 2.324 10 14 3.254-2.324-10-14Zm16.308-22.606-1.872 3.536 34 18 1.872-3.536-34-18Zm22.947-28.229-17 1 .234 3.994 17-1-.234-3.994Z",
    fill: "#FBCB2F",
    fillRule: "nonzero"
  })));
});
var BrokerRatingSuccess = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement(react.Icon, _extends__default["default"]({
    as: Svg
  }, props, {
    ref: ref
  }));
});
exports.BrokerRatingSuccess = BrokerRatingSuccess;